import { QueryKey, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { businessUnitService } from 'src/data/api/orbit-service-ts/business-unit/businessUnitService';
import {
  ListBusinessUnitsCommandInput,
  ListBusinessUnitsCommandOutput,
} from '@amzn/gbsa-orbit-typescript-client';
import { businessUnitKeys } from 'src/data/api/orbit-service-ts/business-unit/queries/keys';

export const useBusinessUnitsQuery = <TData = ListBusinessUnitsCommandOutput>(
  input: Partial<ListBusinessUnitsCommandInput>,
  options?: Omit<
    UseQueryOptions<ListBusinessUnitsCommandOutput, Error, TData, QueryKey>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery({
    ...options,
    queryKey: businessUnitKeys.list(input),
    queryFn: async () => {
      const programId = input.programId;
      if (!programId) {
        throw new Error('Program ID is required');
      }
      const res = await businessUnitService.getAll({
        ...input,
        programId: programId,
      });
      return res;
    },
  });
};
